import { ProfileRedirect } from "@/components/ProfileRedirect";

const NathanielSizemoreProfile = () => {
  return <ProfileRedirect username="nathaniel-sizemore" />;
};

export default NathanielSizemoreProfile;
